import { createFiltersApiClient } from './filtersAPIClient'

export const filtersAPIClient = createFiltersApiClient({})
